import type { IdName } from '$lib/models/types';
import { fetchWithAuth } from '$lib/utils/http/httpUtil';
import { showToast } from '$lib/helpers/toastrHelper';
import { persisted } from 'svelte-persisted-store';
import { get } from 'svelte/store';

export function createAliiConnectTypeStore() {
  const baseUrl: string = '/api/alii-connect-type';

  const initial: IdName[] = [];
  const store = persisted('aliiConnectTypeStore', initial, {
    storage: 'session',
  });

  return {
    get: async (): Promise<IdName[]> => {
      const sessionData = get(store);
      if (sessionData.length > 0) return sessionData;

      const response = await fetchWithAuth(baseUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorMessage = `Failed to fetch connection types (HTTP ${response.status})`;
        showToast({
          title: 'Error',
          message: errorMessage,
          type: 'error'
        });
        return [];
      }

      try {
        const data = await response.json();
        store.set(data);
        return data;
      } catch (error) {
        showToast({
          title: 'Error',
          message: 'Failed to load connection types',
          type: 'error'
        });
        return [];
      }
    },
    isNewWorld: async (id: number): Promise<boolean> => {
      const response = await fetchWithAuth(`${baseUrl}/is-new-world/${id}`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorMessage = `Failed to check if connection type is New World (HTTP ${response.status})`;
        showToast({
          title: 'Error',
          message: errorMessage,
          type: 'error'
        });
        return false;
      }

      try {
        const data = await response.json();
        return data;
      } catch (error) {
        showToast({
          title: 'Error',
          message: 'Failed to check if connection type is New World',
          type: 'error'
        });
        return false;
      }
    }
  };
}

export const aliiConnectTypeStore = createAliiConnectTypeStore();
